import React from 'react';
import email from '../assets/images/Archipelagos_Labs-EmailIcon.svg';
import linkedin from '../assets/images/Archipelagos_Labs-LinkedInIcon.svg';

function Footer() {
    return (
        <div className="FooterSection bg-black px-0 lg:px-12 xl:px-40">
            <div className="MainContainer max-w-7xl my-0 mx-auto">
                <div className="SectionContent px-8 lg:px-12 xl:px-16 py-6 lg:py-8">
                    <div className="Content">
                        <div className="FooterColumn">
                            <div className="FooterLink FooterEmail flex flex-row items-center gap-4">
                                <div className="LinkIcon flex items-center justify-center">
                                    <img src={email} className="EmailIcon w-9" alt="icon" />
                                </div>
                                <div className="LinkTitle pt-1">
                                    <a
                                        className="text-white hover:text-opacity-80"
                                        href="mailto:info@archipelagos-labs.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        info@archipelagos-labs.com
                                    </a>
                                </div>
                            </div>
                            {/* <div className="hidden FooterLink FooterLinkedin">
                                <div className="LinkIcon">
                                    <img src={linkedin} className="LinkedinIcon" alt="icon" />
                                </div>
                                <div className="LinkTitle">
                                    <h3>Linkedin</h3>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

        </div >

    );
}

export default Footer;